import { IRowData } from "@multiweb/types/contracts";
import { Key } from "Global/Base/Utils/EventUtils";
import { registerCustomElement } from "../UI.ElementarControls/Utils/CustomElementUtils";
import { MoveRecordDirection } from "./DataGrid";
import { CheckedDataRow } from "./DataGridSubcontrols/Components/CheckedDataRow";
import { ListDataGrid } from "./ListDataGrid";

export class ValueListDataGrid extends ListDataGrid<CheckedDataRow> {
    public isShowed: boolean;
    private _selectedItems: Set<CheckedDataRow>;

    public get selectedItems(): IterableIterator<CheckedDataRow> {
        return this._selectedItems.values();
    }

    protected override _constructor(): void {
        super._constructor();

        this._selectedItems = new Set<CheckedDataRow>();
        this.fetchCount = 15;

        this.classList.add("ValueListDataGrid");
        //this.mainList_div.className = "compactListDiv";
        this.dataRows = new Array<CheckedDataRow>();
        this.selectedRows = new Array<CheckedDataRow>();
        this.headerRow.visible = false;

        this.registerDataRowFactory(() => new CheckedDataRow());
        this.disposeOnDetach = false;
    }

    protected override async _attachDataGrid(): Promise<any> {
        await super._attachDataGrid();

        for (const column of this.columns) {
            column.disposeOnDetach = false;
        }
    }

    protected override _createRow(data: IRowData): CheckedDataRow {
        //data[this._dataSource.dataKey] =
        const dataRow = this._dataRowFactory(this, data);
        dataRow.init(data, this, this._createRowControlElement(dataRow));

        dataRow.afterAttach(() => {
            if (this.isSelectedAll)
                dataRow.isSelected = true;
            dataRow.registerEventListener("checkedChange", (e: CustomEvent) => {
                const el = e.detail.item as CheckedDataRow;

                if (el.isChecked)
                    this._selectedItems.add(el);
                else {
                    for (const si of this._selectedItems) {
                        if (si.dataKey == el.dataKey) {
                            this._selectedItems.delete(si);
                            break;
                        }
                    }
                }
            });
        });

        this.dataRows.push(dataRow);

        return dataRow;
    }

    protected override _createRows(data: Iterable<IRowData>): void {
        let i = 0;
        for (const row of data) {
            const oKeys = Object.keys(row);
            if (oKeys.length == 0) continue;

            row[this._dataSource.dataKey] = row[oKeys[0]];
            this._createComplexRow(row);

            if (++i >= this.fetchCount)
                break;
        }
    }

    public override insertExistingRecord(dataRow: IRowData): CheckedDataRow {
        return this.insertNewRecord(dataRow);
    }

    public override insertNewRecord(dataRow: IRowData): CheckedDataRow {
        const beforeRow = this.selectedRows.length > 0 && this.dataRows && this.dataRows.length > 0 ? (this.dataRows.indexOf(this.selectedRows[0]) > -1 ? this.selectedRows[0] : undefined) : (this.dataRows.length > 0 ? this.dataRows[0] : undefined);
        const newRow = this._dataRowFactory(this, dataRow);
        const dataSource = this.dataSource;
        newRow.init(dataRow, this, this._createRowControlElement(newRow));
        newRow.render();
        newRow.dataKey = dataRow[dataSource.dataKey].valueOf();

        this.emptyMessage.visible = false;

        if (beforeRow)
            this._dataTable.insertBefore(newRow as HTMLElement, beforeRow as HTMLElement);
        else
            this._dataTable.appendChild(newRow as HTMLElement);

        if (beforeRow) {
            const addIndex = this.dataRows.indexOf(beforeRow);
            this.dataRows.splice(addIndex, 0, newRow); //.push(newRow);
        } else {
            this.dataRows.push(newRow);
        }

        return newRow;
    }

    /**
    * Vyber zaznamu od posledniho kliknuteho po posledni index (pri vyberu zaznamu Shift + Up/Down)
    * @param key - Kod klavesy - sipka nahoru nebo dolu
    */
    public override shiftSelectRecords(key: string = undefined): void {
        this.isSelectedAll = false;
        // mam uz oznaceny radek (radky)
        if (this.lastClickedRow) {
            let fromIndex = this.dataRows.indexOf(this.lastClickedRow); // vezmu naposledy kliknuty radek
            let selectAnotherItem = true;
            let skipSelecting = false;
            let selectTwoItemsDirection = 0; // 0 - není tento případ, 1 - situace při šipce nahoru, -1 - situace při šipce dolů

            if (key === Key.ArrowUp) { // up
                if (this.keyPressRowIndex == -1) { // mimo rozsah
                    this.keyPressRowIndex++;
                    return;
                }
                if (!this.dataRows[this.keyPressRowIndex + 1].isSelected && !this.dataRows[this.keyPressRowIndex].isSelected) { // pokud jsem na neoznačeném záznamu a se shiftem se posunu na další, tak musím označit i ten první
                    selectTwoItemsDirection = 1;
                } else if (this.dataRows[this.keyPressRowIndex].isSelected && this.dataRows[this.keyPressRowIndex + 1].isSelected && fromIndex > (this.keyPressRowIndex)) { // šipkou nahoru se dostanu na označený záznam a zároveň se nejedná o "undo"
                    skipSelecting = true;
                } else if (this.dataRows[this.keyPressRowIndex].isSelected) {
                    selectAnotherItem = false;
                    this.keyPressRowIndex++;
                }
            } else if (key === Key.ArrowDown) { // down
                if (this.keyPressRowIndex == this.dataRows.length) {
                    this.keyPressRowIndex--;
                    return;
                }
                if (!this.dataRows[this.keyPressRowIndex - 1].isSelected && !this.dataRows[this.keyPressRowIndex].isSelected) {
                    selectTwoItemsDirection = -1;
                } else if (this.dataRows[this.keyPressRowIndex].isSelected && this.dataRows[this.keyPressRowIndex - 1].isSelected && fromIndex < (this.keyPressRowIndex)) {
                    skipSelecting = true;
                } else if (this.dataRows[this.keyPressRowIndex].isSelected) {
                    selectAnotherItem = false;
                    this.keyPressRowIndex--;
                }
            }

            let toIndex = this.keyPressRowIndex; // index aktualniho
            let direction = MoveRecordDirection.next;
            if (fromIndex > toIndex) { //v pripade ze index prvniho je vetsi, tak prohodime
                direction = MoveRecordDirection.prev;
                const tmp = fromIndex;
                fromIndex = toIndex;
                toIndex = tmp;
            }
            if (fromIndex < 0) {
                this.keyPressRowIndex = fromIndex = 0;
            }
            if (toIndex >= this.dataRows.length)
                this.keyPressRowIndex = toIndex = this.dataRows.length - 1;

            this._adjustScrollTop(direction, this.dataRows[direction === MoveRecordDirection.next ? toIndex : fromIndex]);

            if (!skipSelecting) {
                for (let i = fromIndex; i <= toIndex; i++) { // prochazime a oznacime radky od fromIndexu po toIndex
                    if (this.keyPressRowIndex == i || (this.keyPressRowIndex + selectTwoItemsDirection) == i) {
                        this.dataRows[i].isSelected = !this.dataRows[i].isSelected;
                    }
                    this._dispatchSelectionChangeEvent(this.dataRows[i].dataKey, { doubleClick: false, clickedRow: this.dataRows[i] });
                }
            }

            if (!selectAnotherItem) {
                if (key === Key.ArrowUp) {
                    this.keyPressRowIndex--;
                } else if (key === Key.ArrowDown) {
                    this.keyPressRowIndex++;
                }
            }

            this._selectedItems.add(this.dataRows[this.keyPressRowIndex]);
        }
    }
}

registerCustomElement("tsc-ValueListDataGrid", ValueListDataGrid);
